import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";

import { EMPTY_ARRAY_LENGTH, inboxReduxConstants } from "../../../constants";
import { hasMoreListItems } from "../../shared/listPaginationUtility";
import LoadingSpinner from "./loadingSpinner";
import ConversationCard from "./conversationCard";

/**
 * Left-rail conversation list with infinite scroll.
 */
const ConversationsSidebarList = ({
  spinner,
  getConversations,
  selectedConversation,
  allCustomerConversation,
  onConversationClick,
}) => {
  const isLoadingConversations = spinner(
    inboxReduxConstants.GET_ALL_CONVERSATIONS,
  );

  const renderSidebarCards = () => {
    if (
      allCustomerConversation.length === EMPTY_ARRAY_LENGTH &&
      isLoadingConversations
    ) {
      return <LoadingSpinner />;
    }

    if (allCustomerConversation.length === EMPTY_ARRAY_LENGTH) {
      return (
        <div className="d-flex justify-content-center p-2">
          No conversation found
        </div>
      );
    }

    return allCustomerConversation.map((conv) => (
      <ConversationCard
        key={conv.id}
        conv={conv}
        selectedConversation={selectedConversation}
        onConversationClick={onConversationClick}
      />
    ));
  };

  return (
    <InfiniteScroll
      dataLength={allCustomerConversation.length}
      next={getConversations}
      hasMore={hasMoreListItems(allCustomerConversation.length)}
      loader={isLoadingConversations && <LoadingSpinner />}
      scrollableTarget="inbox-sidebar"
      className="h-90"
    >
      {renderSidebarCards()}
    </InfiniteScroll>
  );
};

export default ConversationsSidebarList;
